
import React from 'react';
import { useParams } from 'react-router-dom';
import { StudentFormContent } from '../components/student-form/StudentFormContent';
import { Helmet } from 'react-helmet-async';

const StudentForm = () => {
  const { id } = useParams<{ id: string }>();
  const isEditing = Boolean(id);
  
  return (
    <div className="w-full">
      <Helmet>
        <title>{isEditing ? 'Edit Student' : 'Add New Student'} - NALC Student Program & Fee Tracker</title>
      </Helmet>
      <StudentFormContent studentId={id} />
    </div>
  );
};

export default StudentForm;
